<template>
    <div id="edit-agent-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Edit Agent</h1>
                <template v-if="loaded">
                    <AgentForm :formData="agentObject" submitText="Update" @formSubmitted="updateAgent" />
                </template>
            </section>
        </div>
    </div>
</template>

<script>
import AgentForm from '@/components/forms/AgentForm.vue'
const apiBase = process.env.VUE_APP_API_BASE
import axios from 'axios'

export default {
    name: 'AgentsEdit',
    components: {
        AgentForm
    },
    data: function() {
        return {
            agentId: this.$route.params.id,
            agentObject: null,
            loaded: false
        }
    },
    created() {
        axios.get(apiBase + '/agents/' + this.agentId)
            .then(response => {
                this.agentObject = response.data.data
                this.loaded = true
            })
            .catch(error => {
                alert('Could not load agent!')
                console.log(error)
            })
    },
    methods: {
        updateAgent(data) {
            axios.put(apiBase + '/agents/' + this.agentId, data)
                .then(response => {
                    console.log(response)
                    alert('Agent updated successfully')
                    this.$router.push('/agents')
                })
                .catch(error => {
                    alert('Error occurred!')
                    console.log(error)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
